import { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

import { handleHttpErrorStatus } from '../../../../utils/handleHttpErrorStatus';
import ActionGroup from '../../../../common/components/ActionGroup';
import {hetch} from "../../../../utils/fetch.hooked";

function InputSection({ addItem }) {
  const [keyName, setKeyName] = useState('');
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState('');

  return (
    <Box>
      <ActionGroup>
        <TextField
          size="small"
          disabled={isFetching}
          value={keyName}
          onChange={(evt) => {
            setKeyName(evt.target.value?.trimStart().replace(/\s+/g, ' '));
          }}
        />
        <Button
          fullWidth={true}
          title="Добавить имя УКЭП"
          variant="contained"
          size="small"
          disabled={keyName.length < 3 || isFetching}
          endIcon={ isFetching ? <CircularProgress size={24} /> : null }
          onClick={() => {
            setError('');
            setIsFetching(true);
            hetch('/api/key_names', {
              headers: {'Content-Type': 'application/json'},
              method: 'POST',
              body: JSON.stringify({
                key_name: keyName.trim()
              })
            })
              .then(handleHttpErrorStatus)
              .then(res => res.json())
              .then((res) => {
                setKeyName('');
                addItem(res.id, res.key_name);
              })
              .catch(err => err.json())
              .then(res => {
                if (res) {
                  setError(res.message);
                }
              })
              .finally(() => {
                setIsFetching(false);
              })
          }}
        >
          Добавить имя УКЭП
        </Button>
      </ActionGroup>
      {error ? (
        <Box sx={{mt: 2}}>
          <Alert severity="error">{error}</Alert>
        </Box>
      ) : null}
    </Box>
  );
}

export default InputSection;
